import { Typography } from "antd";

const RepairsAndCommissions = () => {
  return (
    <div>
      <Typography.Title level={2}>Coming Soon</Typography.Title>
    </div>
  )
};

export default RepairsAndCommissions;
